
import React from "react";
import { SermonPlan } from "@/hooks/sermon-plans/types";
import { SermonPlanCard } from "./SermonPlanCard";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

interface SermonPlansListProps {
  sermonPlans: SermonPlan[];
  onEdit: (sermon: SermonPlan) => void;
  onDelete: (id: string) => void;
}

export function SermonPlansList({ sermonPlans, onEdit, onDelete }: SermonPlansListProps) {
  if (!sermonPlans || sermonPlans.length === 0) {
    return (
      <Alert className="my-6">
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription>
          No sermon plans found. Create your first plan to get started.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="space-y-4 w-full">
      {sermonPlans.map((sermon) => (
        <div key={sermon.id} className="w-full cursor-pointer">
          <SermonPlanCard 
            sermon={sermon} 
            onEdit={() => onEdit(sermon)}
            onDelete={() => onDelete(sermon.id)}
          />
        </div>
      ))}
    </div>
  );
}
